import script from "./InvoiceForm.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceForm.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceForm.vue?vue&type=style&index=0&id=4f28683a&lang=css"

const __exports__ = script;

export default __exports__